<!-- <kendo-dialog-container></kendo-dialog-container>  -->
<simple-notifications [options]="options"></simple-notifications>
<router-outlet></router-outlet>

